
@switch (columnId) {
  @case ('id') {
    <lib-text-table-column>
      {{ element.id }}
    </lib-text-table-column>
    <lib-table-column-sort [key]="element.id ?? 0"></lib-table-column-sort>
  }
  @case ('name') {
    <lib-text-table-column>
      {{ element.name }}
    </lib-text-table-column>
  }
  @case ('custom') {
    <lib-binary-status-icon
      [value]="element?.isCustom"
      [showPositiveOnly]="true">
    </lib-binary-status-icon>
    <lib-table-column-sort [key]="element.isCustom ? 1 : 0"></lib-table-column-sort>
  }
  @default {
  }
}
